import React from 'react'
import { AiOutlineHeart } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { PRODUCT_DETAILS_URL } from '../../../app/constants';
import { getProductsAccumulatedQtyInCart } from '../../../app/slices/helper';
import { capitalizeFirstLetter, formatIndianCurrency } from '../expFunction';

const ProductCard = (props) => {
  const carts = useSelector(state => state.products.carts);

  let dispatch = useDispatch();
  // Add to Favorite
  const addToFav = async (id) => {
    dispatch({ type: "products/addToFav", payload: { id } })
  }
  const availableStock = props?.data?.availableStock;
  const productAccumulatedQtyInCart = getProductsAccumulatedQtyInCart(props?.data?.id, carts);
  let stockCanBeAdd = availableStock - productAccumulatedQtyInCart;
  if (props?.data?.uploadType == "Product") {
    stockCanBeAdd = Infinity;
  }
  return (
    <>
      <div style={{ height: "480px", width: "300px", padding: "10px", margin: "30px" }} className="product_wrappers_one bg-white rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
        <div className="thumb relative overflow-hidden rounded-lg">
          <Link to={`${PRODUCT_DETAILS_URL}/${props.data.id}`} className="image block">
            <img src={props.data.img} className="w-full h-60 object-cover rounded-lg transition-transform duration-300 hover:scale-110" alt="Product" />
            <img className="hover-image w-full h-60 object-cover rounded-lg absolute top-0 left-0 opacity-0 hover:opacity-100 transition-opacity duration-300" src={props.data.hover_img} alt="Product" />
          </Link>
          <div className="absolute top-3 right-3">
            <span className="badges">
              {props.data?.uploadType === "Offer" ?
                <span className={('sale')}>Offer</span>
                :
                <span className={('hot')}>Sale</span>
              }
            </span>
          </div>

          <div className="actions absolute bottom-3 right-3 space-x-2">
            <a className="action wishlist text-gray-500 hover:text-red-500 transition-colors" title="Wishlist" onClick={() => addToFav(props.data.id)}>
              <AiOutlineHeart size={48} />
            </a>
          </div>
        </div>

        <div className="content mt-3">
          <Link to={`${PRODUCT_DETAILS_URL}/${props.data.id}`} className="hover:text-green-500 transition-colors">
            <h6 className="title mb-3" style={{ fontSize: '0.95rem', fontWeight: '600' }}>

              {capitalizeFirstLetter(props.data.title)}
            </h6>
          </Link>
          <div style={{ display: "flex" }} className="price mb-3 block">
            <h6 style={{ marginRight: "7px" }}>MRP </h6>
            <span
              className="price  block"
              style={{
                fontSize: '1.0rem',
                color: '#4B5563',
                textDecoration: "line-through",
                textDecorationColor: '#990000',
                textDecorationThickness: '2px',
                opacity: 0.85,
                transition: 'color 0.3s ease, transform 0.2s',
                fontWeight: '700'
              }}

            >
              {formatIndianCurrency(props.data.mrp)}
            </span>
          </div>



          <span className="price mb-3 block" style={{ fontSize: '1.00rem', fontWeight: '700', color: 'black' }}>
            {formatIndianCurrency(props.data.price)}
          </span>
          <div className="flex justify-between items-center mt-1">
  {props?.data?.offerImageText && (
    <span
      style={{
        fontSize: '0.95rem',
        fontWeight: '500',
        border: '2px solid #38A169',
        color: 'black',
        padding: '0.5rem 0.75rem', // Increased padding-top and padding-bottom
        borderRadius: '9999px',
      }}
    >
      {capitalizeFirstLetter(props.data.offerImageText)}
    </span>
  )}

{props?.data?.Size?.name && 
  (props?.data?.ProductCategory?.name === "CRICKET SHOES" || 
   props?.data?.ProductCategory?.name === "BADMINTON") && (
    <span
      style={{
        fontSize: '0.95rem',
        fontWeight: '500',
        border: '2px solid #38A169',
        color: 'black',
        padding: '0.5rem 0.75rem', // Increased padding-top and padding-bottom
        borderRadius: '9999px',
      }}
    >
      Size: {capitalizeFirstLetter(props.data.Size.name)}
    </span>
)}

</div>

        </div>

      </div>
    </>

  )
}

export default ProductCard